import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./page-heading.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./page-heading.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { RouterParamsService } from "../../services/route-params.service";
import { UserInformationService } from "../../services/user/user-information.service";
import { filter, take, takeUntil } from "rxjs/operators";
import { UcFirstPipe } from "ngx-pipes";
import { Subject } from "rxjs";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ActivatedRoute, Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../application/view-application/view-application-routing.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let PageHeadingComponent = class PageHeadingComponent {
    routerParamsService;
    currentStepService;
    userInformationService;
    changeDetectorRef;
    router;
    ucFirst;
    route;
    viewApplicationText = SharedConstants.VIEW_APPLICATION_TEXT;
    _destroy$ = new Subject();
    _heading = "";
    standardCase = true;
    listenForRouteParamChangesSubscription;
    set heading(value) {
        if (this.standardCase) {
            this._heading = this.ucFirst.transform(value.toLowerCase());
        }
        else {
            this._heading = value;
        }
    }
    get heading() {
        return this._heading;
    }
    subheading;
    moduleHeading;
    organisationHeading;
    currentModule;
    currentOrganisation;
    currentJobId;
    constructor(routerParamsService, currentStepService, userInformationService, changeDetectorRef, router, ucFirst, route) {
        this.routerParamsService = routerParamsService;
        this.currentStepService = currentStepService;
        this.userInformationService = userInformationService;
        this.changeDetectorRef = changeDetectorRef;
        this.router = router;
        this.ucFirst = ucFirst;
        this.route = route;
    }
    ngOnInit() {
        this.listenForRouteParamChanges();
    }
    listenForRouteParamChanges() {
        const onlyValidParams = this.routerParamsService.params.pipe(filter(param => param.moduleid || param.organisationid));
        this.listenForRouteParamChangesSubscription = onlyValidParams.subscribe((params) => {
            if (params) {
                if (params.moduleid) {
                    this.currentJobId = params.jobID;
                    this.userInformationService.$systemModules.pipe(takeUntil(this._destroy$), take(1)).subscribe((modules) => {
                        if (modules !== undefined && modules !== null && modules.length > 0) {
                            this.currentModule = this.userInformationService.getModuleInformation(+params.moduleid);
                            this.setModuleHeadings();
                        }
                    });
                }
                else if (params.organisationid) {
                    this.userInformationService.$systemOrganisations.pipe(takeUntil(this._destroy$), take(1)).subscribe((organisations) => {
                        if (organisations !== undefined && organisations !== null && organisations.length > 0) {
                            this.currentOrganisation = this.userInformationService.getOrganisationInformation(+params.organisationid);
                            this.setOrganisationPageHeadings();
                        }
                    });
                }
            }
        });
    }
    setModuleHeadings() {
        if (this.currentModule) {
            this.moduleHeading = this.currentModule.name;
            this.organisationHeading = this.currentModule.organisation?.name;
            this.changeDetectorRef.markForCheck();
        }
    }
    setOrganisationPageHeadings() {
        if (this.currentOrganisation) {
            this.organisationHeading = this.currentOrganisation.name;
            this.changeDetectorRef.markForCheck();
        }
    }
    navigateToApplicationDetails($event) {
        this.currentStepService.setLoadStep(false);
        this.router.navigate([ViewApplicationRoutingConstants.APPLICATION_CONTENT_ROUTE, { loadSteps: false }], { relativeTo: this.route.parent?.parent });
    }
    shouldShowViewApplicationLink() {
        return this.router.url.includes("viewapplication") && this.router.url.includes("step");
    }
    static ctorParameters = () => [
        { type: RouterParamsService },
        { type: CurrentStepService },
        { type: UserInformationService },
        { type: ChangeDetectorRef },
        { type: Router },
        { type: UcFirstPipe },
        { type: ActivatedRoute }
    ];
    static propDecorators = {
        standardCase: [{ type: Input }],
        heading: [{ type: Input }],
        subheading: [{ type: Input }]
    };
};
PageHeadingComponent = __decorate([
    Component({
        selector: "app-page-heading[heading]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], PageHeadingComponent);
export { PageHeadingComponent };
